import {TileEdgePortType} from '@colonist/game-states'
import {TranslationObject} from '@colonist/i18n'

export module TipsPort {

    export function title(type: TileEdgePortType): TranslationObject {
        switch(type) {
            case TileEdgePortType.Port: return {key: 'strings:game.ports.general.title'}
            case TileEdgePortType.PortLumber: return {key: 'strings:game.ports.lumber.title'}
            case TileEdgePortType.PortBrick: return {key: 'strings:game.ports.brick.title'}
            case TileEdgePortType.PortWool: return {key: 'strings:game.ports.wool.title'}
            case TileEdgePortType.PortGrain: return {key: 'strings:game.ports.grain.title'}
            case TileEdgePortType.PortOre: return {key: 'strings:game.ports.ore.title'}
        }
    }

    export function body(type: TileEdgePortType): TranslationObject {
        switch(type) {
            case TileEdgePortType.Port: return {key: 'strings:game.ports.general.body'}
            case TileEdgePortType.PortLumber: return {key: 'strings:game.ports.lumber.body'}
            case TileEdgePortType.PortBrick: return {key: 'strings:game.ports.brick.body'}
            case TileEdgePortType.PortWool: return {key: 'strings:game.ports.wool.body'}
            case TileEdgePortType.PortGrain: return {key: 'strings:game.ports.grain.body'}
            case TileEdgePortType.PortOre: return {key: 'strings:game.ports.ore.body'}
        }
    }

}
